export enum StartOptions {
    Default = 0,
    Playlist = 1
}
